/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React, {useEffect, useState} from "react";
import { fetchMarketBreadth } from "../../api";

export default function HomeMarketBreadth() {

    const [breadth, setBreadth] = useState(null);

    useEffect(() => {
        fetchMarketBreadth()
            .then(setBreadth)
            .catch(console.error);
    }, []);

    if (!breadth) return null;

    const total =
        Number(breadth.advancing_stocks) +
        Number(breadth.declining_stocks) +
        Number(breadth.unchanged_stocks);

    const advPct =
        (Number(breadth.advancing_stocks) / total) * 100;

    const decPct =
        (Number(breadth.declining_stocks) / total) * 100;

    const uncPct =
        (Number(breadth.unchanged_stocks) / total) * 100;

    const ratio =
        Number(breadth.declining_stocks) > 0
            ? (
                Number(breadth.advancing_stocks) /
                Number(breadth.declining_stocks)
              ).toFixed(2)
            : "∞";
    console.log("percentages",total,advPct,decPct,ratio,uncPct)
    return (

        <div
            className="
                                bg-gradient-to-r
                from-slate-900
                via-blue-950
                to-slate-900
                rounded-3xl
                shadow-sm
                border
                border-slate-200
                p-6
            "
        >

            <div className="flex justify-between mb-5">

                <h3 className="text-xl font-bold text-slate-100">
                    Market Breadth
                </h3>

                <span
                    className="
                        text-xs
                        px-3
                        py-1
                        rounded-full
                        text-green-500
                        font-medium
                    "
                >
                    LIVE
                </span>

            </div>

            {/* Advancing */}

            <div className="mb-4">

                <div className="flex justify-between mb-1">

                    <span className="text-emerald-600 font-medium">
                        Advancing
                    </span>

                    <span className="text-emerald-600 font-medium">
                        {breadth.advancing_stocks}
                    </span>

                </div>

                <div className="h-3 bg-slate-100 rounded-full">

                    <div
                        className="
                            h-3
                            bg-emerald-500
                            rounded-full
                        "
                        style={{
                            width: `${advPct}%`
                        }}
                    />

                </div>

            </div>

            {/* Declining */}

            <div className="mb-4">

                <div className="flex justify-between mb-1">

                    <span className="text-red-500 font-medium">
                        Declining
                    </span>

                    <span className="text-red-500 font-medium">
                        {breadth.declining_stocks}
                    </span>

                </div>

                <div className="h-3 bg-slate-100 rounded-full">

                    <div
                        className="
                            h-3
                            bg-red-500
                            rounded-full
                        "
                        style={{
                            width: `${decPct}%`
                        }}
                    />

                </div>

            </div>

            {/* Unchanged */}

            <div>

                <div className="flex justify-between mb-1">

                    <span className="text-slate-300 font-medium">
                        Unchanged
                    </span>

                    <span className="text-slate-300 font-medium">
                        {breadth.unchanged_stocks}
                    </span>

                </div>

                <div className="h-3 bg-slate-100 rounded-full">

                    <div
                        className="
                            h-3
                            bg-slate-400
                            rounded-full
                        "
                        style={{
                            width: `${uncPct}%`
                        }}
                    />

                </div>

            </div>

            <div
                className="
                    mt-6
                    pt-4
                    border-t
                    border-slate-200
                    flex
                    justify-between
                "
            >

                <span className="text-slate-200">
                    Breadth Ratio (Adv/Dec)
                </span>

                <span
                    className="
                        font-bold
                        text-slate-200
                    "
                >
                    {ratio}
                </span>

            </div>

        </div>
    );
}